import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/apiClient";
import RecordDialog from "../components/RecordDialog";
import PhotoGallery from "../components/PhotoGallery";
import { Button } from "../components/ui/button";
import { StatusBadge } from "../components/StatusBadge";
import { Plus, WarningDiamond } from "@phosphor-icons/react";

export default function Punctures() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const load = () => api.get("/punctures").then(({ data }) => setRows(data));
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <div>
          <div className="overline text-amber-500 flex items-center gap-2"><WarningDiamond size={14} /> Field Reports</div>
          <h1 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl">Puncture & Damage Reports</h1>
        </div>
        <Button data-testid="add-puncture-btn" onClick={() => setOpen(true)} className="bg-amber-500 font-bold text-zinc-950 hover:bg-amber-400">
          <Plus size={16} weight="bold" className="mr-1" /> New Report
        </Button>
      </div>

      <div className="overflow-x-auto rounded-sm border border-zinc-800">
        <table className="w-full min-w-[680px] text-sm">
          <thead className="bg-zinc-900 text-left overline text-zinc-500">
            <tr>
              <th className="px-4 py-3">Report #</th><th className="px-4 py-3">Tyre</th>
              <th className="px-4 py-3">Type</th><th className="px-4 py-3">Cost</th>
              <th className="px-4 py-3">Outcome</th><th className="px-4 py-3">Photos</th><th className="px-4 py-3">Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-800">
            {rows.map((p) => (
              <tr key={p.id} data-testid={`puncture-row-${p.id}`} onClick={() => navigate(`/tyres/${p.tyre_id}`)} className="cursor-pointer bg-zinc-950 hover:bg-zinc-900">
                <td className="px-4 py-3 font-mono font-bold text-amber-500">{p.report_number}</td>
                <td className="px-4 py-3 font-mono">{p.serial_number}</td>
                <td className="px-4 py-3 text-zinc-400">{p.puncture_type}</td>
                <td className="px-4 py-3 tabular-nums">R {p.repair_cost}</td>
                <td className="px-4 py-3"><StatusBadge status={p.repaired ? "Under Repair" : "Removed"} /></td>
                <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}><PhotoGallery photos={[...(p.photos_before || []), ...(p.photos_after || [])]} thumb="h-10 w-10" testid={`puncture-photo-${p.id}`} /></td>
                <td className="px-4 py-3 text-zinc-500">{new Date(p.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="px-4 py-8 text-center text-zinc-500">No reports</td></tr>}
          </tbody>
        </table>
      </div>

      {open && <RecordDialog action="puncture" open={open} onOpenChange={setOpen} onDone={load} />}
    </div>
  );
}
